module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interaction-information"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.monograph.data.Id),
      expression: "!monograph.data.Id"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.loadingText))])]), _vm._v(" "), (_vm.monograph.data.Id) ? _c('div', {
    staticClass: "monograph"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.monograph.data.Title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h6', {
    attrs: {
      "id": "severity_level"
    }
  }, [_vm._v(_vm._s(_vm.severityLevelText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.SeverityLevel || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "mechanism"
    }
  }, [_vm._v(_vm._s(_vm.mechanismOfActionText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Mechanism || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "clinical_effects"
    }
  }, [_vm._v(_vm._s(_vm.clinicalEffectsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.ClinicalEffects || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "predisposing_factors"
    }
  }, [_vm._v(_vm._s(_vm.predisposingFactorsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.PredisposingFactors || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "patient_management"
    }
  }, [_vm._v(_vm._s(_vm.patientManagementText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.PatientManagement || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "discussion"
    }
  }, [_vm._v(_vm._s(_vm.discussionText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Discussion || _vm.emptyText))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c6153d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractionInformation.vue
// module id = 321
// module chunks = 5 7 8